import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Link2 } from 'lucide-react'
import clientesService from '../../services/clientesService'
import { useOrganizador } from '../../contexts/OrganizadorContext'
import SubmissaoCadastroPublicoCard from '../../components/clientes/SubmissaoCadastroPublicoCard'

const PER_PAGE = 20

export default function CadastrosPublicosLista() {
  const navigate = useNavigate()
  const { organizadorAtivo } = useOrganizador()
  const organizadorId = organizadorAtivo?.id

  const [submissoes, setSubmissoes] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    if (organizadorId) carregar(1)
  }, [organizadorId])

  // Marca como vistos ao abrir a tela — zera o badge de "novos" na tela de Clientes
  useEffect(() => {
    if (organizadorId) {
      clientesService.marcarVistasSubmissoesCadastroPublico(organizadorId).catch(() => {})
    }
  }, [organizadorId])

  const carregar = async (pagina) => {
    try {
      setLoading(true)
      const resposta = await clientesService.listarTodasSubmissoesCadastroPublico(organizadorId, pagina, PER_PAGE)
      setSubmissoes(resposta.data || [])
      setTotalPages(resposta.total_pages || 1)
      setTotal(resposta.total || 0)
      setPage(pagina)
    } catch (error) {
      console.error('Erro ao carregar cadastros públicos:', error)
      setSubmissoes([])
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-xl px-4 sm:px-6 py-4 sm:py-6">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/clientes')}
            className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/20 transition-all"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <Link2 className="w-7 h-7 text-white flex-shrink-0" />
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-white">Cadastros Recebidos</h1>
            <p className="text-blue-100 mt-0.5 text-sm">
              {total > 0 ? `${total} envio${total > 1 ? 's' : ''} pelo link de cadastro público` : 'Envios pelo link de cadastro público'}
            </p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-16">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-rematei-blue"></div>
        </div>
      ) : submissoes.length === 0 ? (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-10 text-center text-gray-500">
          Nenhum cadastro recebido pelo link público ainda.
        </div>
      ) : (
        <>
          <div className="space-y-4">
            {submissoes.map((s) => (
              <SubmissaoCadastroPublicoCard key={s.id} submissao={s} mostrarCliente />
            ))}
          </div>

          {totalPages > 1 && (
            <div className="flex items-center justify-center gap-2 pt-2">
              <button
                onClick={() => carregar(page - 1)}
                disabled={page === 1}
                className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-40"
              >
                Anterior
              </button>
              <span className="text-sm text-gray-500">Página {page} de {totalPages}</span>
              <button
                onClick={() => carregar(page + 1)}
                disabled={page === totalPages}
                className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-40"
              >
                Próxima
              </button>
            </div>
          )}
        </>
      )}
    </div>
  )
}
